module.exports = __webpack_public_path__ + "img/aipc.14161f54.jpg";